const createMuiMenu = () => ({
  styleOverrides: {
    list: {
      paddingTop: 0,
      paddingBottom: 0
    }
  }
});
export {
  createMuiMenu as default
};
